export const SERVER_URL = process.env.VUE_APP_SERVER_URL!;
export const BASE_API_URL = 'https://api.babyfaceplatform.com';
export const TEST_SERVER_URL = `${BASE_API_URL}/test`;
export const PROD_SERVER_URL = `${BASE_API_URL}/production`;
export const LOGIN_COOKIE = 'mpfLogin';
export const MPF_ABOUT_URL = 'https://pain1.godaddysites.com/about-1';
